import { render, staticRenderFns } from "./Deli.vue?vue&type=template&id=0e57c9a8&scoped=true"
import script from "./Deli.vue?vue&type=script&lang=js"
export * from "./Deli.vue?vue&type=script&lang=js"
import style0 from "./Deli.vue?vue&type=style&index=0&id=0e57c9a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e57c9a8",
  null
  
)

export default component.exports